<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                    <div class="card-header card-header-info">
                        <h4 class="card-title ">Tambah Mitra</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Nama</label>
                                        <input type="text" class="form-control" placeholder="Nama..." v-model="tambah.form.nama">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">WA</label>
                                        <input type="number" class="form-control" placeholder="Wa..." v-model="tambah.form.wa">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Alamat</label>
                                        <input type="alamat" class="form-control" placeholder="Alamat..." v-model="tambah.form.alamat">
                                    </div>
                                </div>
                                <div class="form-group" v-show="tambah.form.id == null">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Bandwith (mb)</label>
                                        <input type="number" class="form-control" placeholder="Bandwith..." v-model="tambah.form.bw">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Harga</label>
                                        <input type="number" class="form-control" placeholder="Harga..." v-model="tambah.form.harga">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="bmd-label-floating text-success">Diskon</label>
                                        <input type="number" class="form-control" placeholder="Diskon..." v-model="tambah.form.diskon">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Tanggal Tagihan (mis: 1 - 28)</label>
                                        <input type="number" class="form-control" placeholder="Bandwith..." v-model="tambah.form.tanggal">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Tanggal Register</label>
                                        <vuejs-datepicker :format="tambah.customFormatter" placeholder="Tanggal Register..." style="width:100%" v-model="tambah.form.register"></vuejs-datepicker>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">NIK (Opsional)</label>
                                        <input type="number" class="form-control" placeholder="No. KTP..." v-model="tambah.form.nik">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Area</label>
                                                <select class="form-control" id="exampleFormControlSelect1" placeholder="Pilih Resto..."  v-model="tambah.form.areaPilih">
                                                    <option value="" selected disabled>Pilih Area</option>
                                                    <option v-for="(u, index) in tambah.form.area" :value="u.id" >{{u.nama}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!--
                                <div class="form-group">
                                    <label class="bmd-label-floating">Beatcom Owner #ID (Misal Akun Demo Owner IDnya : 7)</label>
                                    <input type="number" class="form-control" placeholder="Owner id..." v-model="tambah.form.beatcomid" style="width: 300px">
                                    <label class="bmd-label-floating mt-2">No Hp Owner (Pastikan Nomernya sesuai dengan di Aplikasi)</label>
                                    <input type="number" class="form-control" placeholder="No Hp Owner..." v-model="tambah.form.beatcomhp" style="width: 300px">

                                    <div class="p-2 mt-2" v-show="tambah.form.beatcomnama != null">
                                        Owner id : {{ tambah.form.beatcomid }}</br> Nama : {{ tambah.form.beatcomnama }}</br> Hp : {{ tambah.form.beatcomhp }}
                                    </div>

                                    <div class="input-group-append">
                                        <button class="btn btn-info" @click="tambah.cekOnwer()">Check</button>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="bmd-label-floating">Role </label>
                                        <select v-model="tambah.form.role" class="form-control">
                                            <option value="pilih" disabled selected>Pilih Sebagai</option>
                                            <option value="" v-show="tambah.form.as != 'isp'">Mitra</option>
                                            <option value="pop" v-show="tambah.form.as == 'isp'">POP</option>
                                        </select>
                                    </div>
                                </div>
                                -->
                                <div class="form-group" v-show="data.alert">
                                    <div class="alert alert-danger" role="alert">
                                        {{data.alertText}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <button class="btn btn-primary" @click="tambah.submit">Simpan</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'

// use the APIs
import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

Vue.use(moment)

export default {
	components: { 
		vuejsDatepicker,
		moment,
	}, 
	setup() {
        const data = reactive({
            alert: false,
            alertText: ''
        })

		const tambah = { 
			form: reactive({
                as: null,
                id: null,
				nama: "",
				wa: "",
				alamat: "",
				bw: "",
				harga: "",
				tanggal: "",
				register: "",
                diskon: "0",
                nik: "",
                area: [],
                areaPilih: "",
                beatcomid: null,
                beatcomhp: null,
                beatcomnama: null,
                beatcomstat: "tidak", // ada / tidak
                role: "pilih"
			}),
            customFormatter(date) {
                return moment(date).format('YYYY-MM-DD');
            },
            cekOnwer() {
                if(tambah.form.beatcomid == null) {
                    data.alert = true;
                    data.alertText = "ID Owner tidak boleh kosong";
                    return false;
                }

                if(tambah.form.beatcomid != null) {
                    if(tambah.form.beatcomhp == null) {
                        data.alert = true;
                        data.alertText = "No HP Owner tidak boleh kosong";
                        return false;
                    }
                }
                
                data.alert = false;
                
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken'),
                    bid: tambah.form.beatcomid,
                    hp: tambah.form.beatcomhp,
                }
				
                var apiUrl = inter.MitraCek();
				myGlobal.call(datax,apiUrl).then(x => {
					//myGlobal.loger(x);

					if (x.status) {
                        let data = x.data;

                        tambah.form.beatcomnama = data.nama;

                        tambah.form.beatcomstat = "ya";
                        
					} else {

						//alert(x.pesan);

                        data.alert = true;
                        data.alertText = x.pesan;

					}
				})


            },
            
            getArea() {
                
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken')
                }
				
                var apiUrl = inter.MitraArea();
				myGlobal.call(datax,apiUrl).then(x => {
					// myGlobal.loger(x);

					if (x.status) {

                        let data = x.data;

                        tambah.form.area = data;

                        //console.log(data.as);


					} else {

						//alert(x.pesan);

                        data.alert = true;
                        data.alertText = x.pesan;

					}
				})


            },

            cekIsISP() {
                
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken')
                }
				
                var apiUrl = inter.IsISP();
				myGlobal.call(datax,apiUrl).then(x => {
					//myGlobal.loger(x);

					if (x.status) {

                        let data = x.data;

                        tambah.form.as = data.as;

                        //console.log(data.as);


					} else {

						//alert(x.pesan);

                        data.alert = true;
                        data.alertText = x.pesan;

					}
				})


            },
			submit() {

                var datac = tambah.form;

                if (datac.nama == "") {
                    data.alert = true;
                    data.alertText = "Nama tidak boleh kosong";
                    return false;
                }

                if (datac.wa == "") {
                    data.alert = true;
                    data.alertText = "Nomer WA tidak boleh kosong";
                    return false;
                }

                if (datac.alamat == "") {
                    data.alert = true;
                    data.alertText = "Alamat tidak boleh kosong";
                    return false;
                }

                if (datac.id == null) {
                    if (datac.bw == "") {
                        data.alert = true;
                        data.alertText = "Bandwith tidak boleh kosong";
                        return false;
                    }
                }

                if (datac.harga == "") {
                    data.alert = true;
                    data.alertText = "Harga tidak boleh kosong";
                    return false;
                }

                if (datac.tanggal == "") {
                    data.alert = true;
                    data.alertText = "Tanggal tidak boleh kosong";
                    return false;
                } else {
                    if (parseInt(datac.tanggal) < 1 || parseInt(datac.tanggal) > 28) {
                        data.alert = true;
                        data.alertText = "Tanggal harus di antara 1 - 28 tidak boleh kosong";
                        return false;
                    }
                }

                if (datac.register == "") {
                    data.alert = true;
                    data.alertText = "Tanggal Register tidak boleh kosong";
                    return false;
                }

                if (datac.areaPilih == "") {
                    data.alert = true;
                    data.alertText = "Area tidak boleh kosong";
                    return false;
                }
                
                /*
                if (datac.beatcomid != null) {
                    if (datac.beatcomstat == "tidak") {
                        data.alert = true;
                        data.alertText = "Owner id Tidak ditemukan";
                        return false;
                    }
                }
                    */


                data.alert = false;

                /** 
                if () {
                    return false;
                }
                */
                
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken'),
                    id: datac.id,
                    nama: datac.nama,
                    wa: datac.wa,
                    alamat: datac.alamat,
                    bw: datac.bw,
                    harga: datac.harga,
                    tanggal: datac.tanggal,
                    diskon: datac.diskon,
                    beatcomid: datac.beatcomid,
                    role: datac.role,
                    register: datac.register,
                    nik: datac.nik,
                    area: datac.areaPilih
                }
				
                if (datac.id == null) {
                    var apiUrl = inter.MitraTambah();
                } else {
                    var apiUrl = inter.MitraUpdate();
                }
				
				myGlobal.call(datax,apiUrl).then(x => {
					// myGlobal.loger(x);
					if (x.status) {
						location.href="#/mitra"
					} else {
						alert(x.pesan);
					}
				})
			}
		}

		return {
            data,
			tambah,
			myGlobal
		}
  	},
	mounted() {

        // this.tambah.cekIsISP();
        this.tambah.getArea();
        
        if (this.$route.params.data != null) {
            var params = this.$route.params.data;
            //console.log(JSON.stringify(params));

            this.tambah.form.id = params.mid;
            this.tambah.form.nama = params.nama;
            this.tambah.form.wa = params.wa;
            this.tambah.form.alamat = params.alamat;
            this.tambah.form.harga = params.harga;
            this.tambah.form.tanggal = params.tgl_tagihan;
            this.tambah.form.diskon = params.diskon;

        }

        /*
            
				: "",
				: "",
				: "",
				bw: "",
				: "",
				: ""
        */

	}
	/*
  	data() {
		return {
			title: "Detail Servis",
            nama: '', 
		}
	},
	methods: {
        Simpan() {
			var data = new FormData();
            data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
            data.append('nama', this.nama);
			
            var apiUrl = 'TambahArea';
            
			this.PostData(data,apiUrl).then(x => {
				this.loger(x);
				if (x.status) {
                    location.href="#/area"
				} else {
				    alert(x.pesan);
				}
			})
        }
	}
	*/
}
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.file-upload {
    opacity: 1 !important;
    position: relative !important;
    z-index: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/mitra/tambah.vue